import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Button,
  LinearProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Popover,
  Typography
} from "@material-ui/core";
import { extent } from "d3-array";
import Chart from "./CastDistChart";
import Brush from "./Brush";

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec"
];

function HelpPopover() {
  const [anchorEl, setAnchorEl] = React.useState(null);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Button
        aria-describedby={id}
        variant="outlined"
        color="default"
        onClick={handleClick}
      >
        Help
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
      >
        <Typography style={{ padding: "8px" }}>
          <strong>BRUSH: </strong>Highlight a selection on the lower context
          chart to zoom in. Click and drag the highlighted area to move the
          selection, or the darker bar handles to change its width. <br />
          <strong>DEPTH: </strong>Dark blue lines on lower chart show cast
          depth. Depending on your selection it might be hard to see individual
          casts- please use this feature to get an overall idea of sampling
          depth.
        </Typography>
      </Popover>
    </div>
  );
}

function formatDates(data) {
  const range = extent(data, d => d.time);
  const formatRange = range.map(
    d => `${monthNames[new Date(d).getMonth()]} ${new Date(d).getFullYear()}`
  );

  // .map(x => timeMonth.round(x));
  return `${formatRange[0]} - ${formatRange[1]}`;
}

class CastDistChartModal extends Component {
  constructor(props) {
    super(props);

    this.onResize = this.onResize.bind(this);
    this.state = {
      screenWidth: 1000,
      screenHeight: 600,
      margin: 50,
      brushHeight: 50
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.onResize, false);
    this.onResize();
  }

  onResize() {
    setTimeout(
      this.setState({
        screenWidth: window.innerWidth - 100,
        screenHeight: window.innerHeight - 185
      }),
      100
    );
  }

  render() {
    return (
      <Dialog fullScreen open={this.props.castDistChartModalOpen}>
        <DialogTitle>Distribution of casts in search results</DialogTitle>
        <DialogContent>
          {this.props.castDistChartModalOpen &&
          !this.props.castDistChartDataIsFetching ? (
            <span>
              <Typography variant="subtitle1">
                <b>Search results:</b> {this.props.castDistChartData.length}{" "}
                casts from {formatDates(this.props.castDistChartData)}{" "}
                &nbsp;&nbsp;
                <b>Current selection:</b>{" "}
                {this.props.brushedCastDistChartData.length} casts from{" "}
                {formatDates(this.props.brushedCastDistChartData)}&nbsp;&nbsp;
              </Typography>

              <Chart
                height={this.state.screenHeight - this.state.brushHeight}
                width={this.state.screenWidth}
                margin={this.state.margin}
                data={this.props.brushedCastDistChartData}
              />
              <Brush
                width={this.state.screenWidth}
                margin={this.state.margin}
                data={this.props.castDistChartData}
                setBrushExtent={this.props.onSetBrushExtent}
                brushDidInvalidate={this.props.brushDidInvalidate}
                brushDidClear={this.props.brushDidClear}
              />
            </span>
          ) : (
            <LinearProgress />
          )}
        </DialogContent>
        <DialogActions>
          <HelpPopover />
          <Button
            variant="outlined"
            color="default"
            onClick={() =>
              this.props.onClearBrush(
                extent(this.props.castDistChartData, d => d.time)
              )
            }
          >
            Reset brush
          </Button>
          <Button
            variant="contained"
            onClick={this.props.onCastDistChartModalClose}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const dataShape = PropTypes.shape({
  time: PropTypes.date,
  depth: PropTypes.number
});

CastDistChartModal.propTypes = {
  onCastDistChartModalClose: PropTypes.func.isRequired,
  castDistChartModalOpen: PropTypes.bool.isRequired,
  castDistChartDataIsFetching: PropTypes.bool.isRequired,
  castDistChartData: PropTypes.arrayOf(dataShape).isRequired,
  brushedCastDistChartData: PropTypes.arrayOf(dataShape).isRequired,
  onSetBrushExtent: PropTypes.func.isRequired,
  onClearBrush: PropTypes.func.isRequired,
  brushDidClear: PropTypes.func.isRequired,
  brushDidInvalidate: PropTypes.bool.isRequired
};

export default CastDistChartModal;
